var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Voice',{attrs:{"detail":{
  no: '06',
  belong: '本社',
  profile: '本社',
  title: '人事部マネージャー',
  name: '内田 塁',
  date: '２０１９年入社',
  sm: {
    belong: '本社',
    name: '人事部マネージャー',
  },
  intro: 'サービススタッフから、本社勤務へ。ホテル現場とオフィスを円滑につなぎ、会社全体の成長に関わりたい',
  content: [
    {
      title: 'メーカー勤務から接客業へ転身',
      text: '学生時代に製造業でアルバイトをしていた時、お客さまに対応する時間がありました。メイン業務ではないのにとても楽しくて、「私は人と接するのが好きなのだ」と気付きました。それが接客業への興味の始まりです。新卒でメーカーに就職し東京で働いていたものの、やはり人と接したい、そして留学で磨いた韓国語も活かしたい思いが強くなり、転職を決意。地元の京都から祖父母がいる佐賀へよく帰省して九州が好きだったこと、博多駅を通るたび福岡に住みたいと願うほど惹かれたこともあってＪＲ九州ホテルズアンドリゾーツを志望しました。',
    },
    {
      title: '会話と観察からお客さまの「嫌」を察知',
      text: 'まずＪＲ九州ホテルブラッサム福岡でアルバイトとして採用され、翌年正社員として入社しました。接客に興味はあったものの、現実は未経験。当初は「本当に自分に合っているのか？」と悩む日々でした。お客さまに喜ばれると思って行動しても、自分が思うように感じてくださるとは限らず、逆によく思われないことも多々ありました。自分本位の判断では接客できないのです。かといって、何もしなければ期待にも応えられません。それでも日々お客さまと会話し、行動を観察するうちに、その方の「されたら嫌なこと」が少しずつ見えてくるようになりました。すると何をしたら良いか気が付くようになり、お客さまに喜んでいただける機会が増えました。今はとてもやりがいを感じますし、周囲から天職だと言われます。やはり私は人と接するこの仕事が好きです。長く携わりたいと思っています。',
    },
    {
      title: 'ホテル現場とは異なる本社業務の面白さ',
      text: '現在は本社の総務企画課で、新人スタッフ研修で使用するマニュアルの動画化など進めています。ホテルの現場にいた経験から、現場と本社との連携を円滑にし、気軽に頼られる存在でありたいと思っています。ホテルと違い、本社で接するのは取引先の方々です。他社の方のお話には刺激を受けることも多く、会社を内側から良くしていきたいというモチベーションが湧きます。JR九州の「ななつ星」のクルーの方や客室乗務員の方のお話を聞く機会もあり、ホテルとは異なるサービス内容に私たちにも活かせるのではと感じました。外部、他業種の方との出会いは、本社ならではの魅力です。',
    },
    {
      title: '人を喜ばせること、相手を気遣うこと',
      text: '私には「エンターテイナーでありたい」という目標があります。舞台に立ちたいという意味ではなく、「おもてなしを通じて人を喜ばせるエンターテイナー」でありたい。ホテル入社時からの目標で、今後もずっとこれを軸に生きていくと思います。お客さまはもちろん、一緒に働くスタッフや家族、友人も同じで、対象は周囲の人全員です。人を喜ばせることが根っから好きなのでしょうね（笑）。これから入社するみなさんにも、そういった軸やマインドを持ってもらえたらと思います。',
    } ],
  career: [
    {
      year: '2019',
      text: 'ＪＲ九州ホテルブラッサム福岡　ホテルスタッフとして入社',
    },
    {
      year: '2021',
      text: 'THE BLOSSOM KUMAMOTO　開業準備のスタッフとして配属',
    },
    {
      year: '2021',
      text: 'ＪＲ九州ホテルブラッサム福岡　ホテルスタッフとして配属',
    },
    {
      year: '2022',
      text: '本社　総務企画課に配属',
      isLast: true,
    },
    {
      year: '2023',
      text: 'マネージャーに昇格、本社　人事部へ異動',
      isLast: true,
    },
    {
      year: '',
      text: '',
    } ],
  message: 'ホテルには人を楽しませ、喜んでもらう機会がたくさんあります。<br>しかし（新人が皆経験する）フロントは、お客さまと接する以外に事務作業など見えない仕事も多く、お客さまを優先できない場合があるかもしれません。<br>それでも本来の仕事は、お客さまに喜んでいただくこと、感動していただくことです。<br>その点をしっかり軸に持ち、「おもてなしを通じて人を喜ばせるエンターテイナー」の一人として楽しんでほしいです。',
  caption: true,
  navi: {
    prev: {
      title: '笑顔を忘れずに、温泉宿ならではのお客さま一人ひとりに寄り添うサービスを。',
      path: '05',
    },
    next: {
      title: 'ホテルは私らしく成長できる場所。笑顔と明るさ、特技も活かして誰もが楽しい空間を作りたい。',
      path: '07',
    },
  },
}}})}
var staticRenderFns = []

export { render, staticRenderFns }